import React from 'react';
import { formatDuration } from '../../helpers/boh_spotlights';
const getOverUnder = (goal, current) => {
  if (isNaN(goal) || isNaN(current)) return undefined;
  return -(goal - current);
};
const formatOverUnder = value => {
  if (isNaN(value)) return '-';
  if (value > 0) {
    return `+${value}s`;
  } else {
    return `${value}s`;
  }
};
const Row = ({
  location,
  own,
  accent_color
}) => {
  const diff = getOverUnder(parseFloat(location.goal), parseFloat(location.value));
  const diffClassName = diff < 0 ? 'green' : 'red';
  return /*#__PURE__*/React.createElement("div", {
    className: `list-row list-item ${location.ranking === (own === null || own === void 0 ? void 0 : own.ranking) && 'list-item-own'}`,
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "left"
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, location.ranking, "."), " ", location.location)), /*#__PURE__*/React.createElement("p", {
    className: "center"
  }, location.goal ? `${formatDuration(parseFloat(location.goal))}` : '-'), /*#__PURE__*/React.createElement("p", {
    className: "center"
  }, location.value ? `${formatDuration(parseFloat(location.value))}` : '-'), /*#__PURE__*/React.createElement("p", {
    className: "right"
  }, /*#__PURE__*/React.createElement("span", {
    className: diffClassName
  }, formatOverUnder(diff))));
};
export default Row;